import { AfterViewInit, Component, ElementRef, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { AbsiResource, AbsiTemplateResource, AbsiTemplateTypeResource, SaveAbsiResource, SaveAbsiStatusResource } from './absi';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { FormStatusEnum, LoadingOrigin } from 'src/app/common/enumerations/enumerations';
import { CatlReportComponent } from 'src/app/controls/catl/catl-report/catl-report.component';
import { CommentsSummaryComponent } from 'src/app/controls/comments-summary/comments-summary.component';
import { Observable, Subscription } from 'rxjs';
import { MessagePlaceholder } from 'src/app/common/models/placeholder';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { AbsiService } from './absi.service';
import { RejectDialogComponent } from 'src/app/controls/reject-dialog/reject-dialog.component';
import { MessageTypeEnum } from '../messages/services/message-banner.enums';
import { Schedule } from '../schedules/models/schedule';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { AbsiTemplateTypeRefresh } from './store/absi-template-type/absi-template-type.action';
import { AbsiSidePanelComponent } from './absi-side-panel/absi-side-panel.component';
import { AbsiUpdate } from './store/absi/absi.action';

@Component({
  selector: 'absi',
  templateUrl: './absi.component.html',
  styleUrls: ['./absi.component.scss', '../../../quill-helper.scss']
})
export class AbsiComponent extends BaseComponent implements OnInit, AfterViewInit {

  absi?: AbsiResource;

  @ViewChild("sidenav") sidenav!: MatSidenav;
  @ViewChild("headerTop") headerTop!: ElementRef;

  @ViewChild(AbsiSidePanelComponent) side?: AbsiSidePanelComponent;

  tmpEndstations!: string;

  disabled: boolean = false;

  resourceRequired: boolean = false;

  filterCtrl = new FormControl();

  errorMessages: string[] = [];
  headerOnTop: boolean = false;

  valueFilter!: string;
  createdOn!: string;

  ///////
  tmpFilter!: string;
  condition!: string;
  filteredFilter: any[] = [];
  currentFilter: any;
  filter: any;

  // absiUnchanged?: Absi | null;
  absis: AbsiResource[] = [];
  absis$!: Observable<AbsiResource[]>;
  absisSubs: Subscription = new Subscription;

  schedule?: Schedule;
  schedules?: Schedule[];
  schedulesFiltered?: Schedule[];
  schedulesSubs!: Subscription;

  absiTemplateType?: AbsiTemplateTypeResource;
  absiTemplateTypes?: AbsiTemplateTypeResource[];
  absiTemplateTypesFiltered?: AbsiTemplateTypeResource[];
  absiTemplateTypesSubs!: Subscription;

  absiTemplate?: AbsiTemplateResource;
  absiTemplates?: AbsiTemplateResource[];
  absiTemplatesFiltered?: AbsiTemplateResource[];
  absiTemplatesSubs!: Subscription;

  loadingMessage!: string;

  showAmendmentToggle: boolean = false;
  //////

  isCreating?: boolean;
  private resizeTimer: any;

  constructor(
    protected override injector: Injector,
    private service: AbsiService
  ) {
    super(injector);
  }

  ngAfterViewInit(): void {
    this.setHeights();
    this.disableSchedules();
  }

  ngOnInit() {
    this.moduleTitle = 'ABSI Checklists';
    this.loadAbsis();
    this.loadSchedules();
    // The active template may have changed in the builder before this page opens.
    this.store.dispatch(new AbsiTemplateTypeRefresh());
    this.loadAbsiTemplateTypes();
  }

  loadAbsis() {
    this.absis$ = this.store.select(state => state.Absi.data);
    this.absisSubs = this.absis$.subscribe(data => {
      if (data?.length) {
        this.absis = data;
        if (this.absi) {
          const absi = this.absis.find(a => a.id == this.absi?.id);
          if (absi?.status != this.absi.status)
            this.alert.message('formStateChanged', [new MessagePlaceholder('{serialNo}', this.absi?.serialNo), new MessagePlaceholder('{status}', absi?.formStatus?.name)]);
          this.absi = absi;
        }
      }
    });
  }

  loadSchedules() {
    this.schedulesSubs = this.store.select(state => state.Schedules.data).subscribe((data: Schedule[]) => {
      if (data?.length) {
        this.schedules = data.filter(s => s.typeId == 1 && s.statusId != 2 && s.statusId != 7);
        this.schedules.forEach(s => {
          s.name = s.scheduleResources.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.resource?.name ?? a.resourceString, b.resource?.name ?? b.resourceString)).map(r => r.resource?.name ?? r.resourceString).join(', ');
        });
        this.schedules.sort((a, b) => this.utils.sortArrayAlphabeticallyWithComplexNumbers(a.name, b.name));
        this.schedulesFiltered = this.schedules;
      }
    });
  }

  disableSchedules() {
    this.schedules?.forEach(s => {
      const exists = this.side?.absis?.find(x => x.resourceName == s.name && x.status != FormStatusEnum.Closed && x.status != FormStatusEnum.Canceled);

      s.disabled = !!exists;
    });
  }

  loadAbsiTemplateTypes() {
    this.absiTemplateTypesSubs = this.store.select(state => state.AbsiTemplateType.data).subscribe(data => {
      if (data?.length) {
        this.absiTemplateTypes = data;
        this.absiTemplateTypesFiltered = this.absiTemplateTypes?.filter(a => a.status == 1);
        if (this.absiTemplateTypesFiltered?.length == 1)
          this.absiTemplateType = this.absiTemplateTypesFiltered[0];
      }
    });
  }

  filterAbsiTemplateTypes(e?: any) {
    const filterValue = e?.target.value?.toLowerCase();
    this.absiTemplateTypesFiltered = this.absiTemplateTypes?.filter(
      (o) => o.name?.toLowerCase().includes(filterValue)
    );
  }

  onAbsiTemplateTypeSelected(e: MatAutocompleteSelectedEvent) {
    this.absiTemplateType = e.option?.value as AbsiTemplateTypeResource;
    this.absi!.type = this.absiTemplateType.id;
    this.absi!.typeName = this.absiTemplateType.name;
    const template = this.absiTemplateType.absiTemplates?.find(x => x.status == 1);
    this.absi!.versionName = template?.name;
    this.absi!.wfTableID = template?.wfTableID;
  }

  override ngOnDestroy(): void {
    this.absisSubs?.unsubscribe();
    this.schedulesSubs?.unsubscribe();
    this.absiTemplateTypesSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  clear() {
    this.errorMessages = [];
  }

  @HostListener("window:resize")
  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 768) {
        this.isExpanded = false;
      }
    }, 200);
  }

  @HostListener("window:scroll")
  isHeaderOnTop() {
    let elemRec;
    if (this.headerTop?.nativeElement !== undefined) {
      elemRec = this.headerTop.nativeElement.getBoundingClientRect();
      const docViewTop = window.screenTop;
      const elemTop = elemRec.top;
      if (elemTop <= docViewTop) {
        this.headerOnTop = true;
      } else {
        this.headerOnTop = false;
      }
    } else {
      this.headerOnTop = false;
    }
  }

  applyFilter(e: any) {
    if (!e)
      this.valueFilter = '';
    this.filter = e;
  }

  /**
   * Shows the ABSI checklist picked from the list after a short delay. On screens narrower than 992px, picking a different checklist also collapses the side panel so the checklist gets the full width.
   * @param e The ABSI checklist picked from the list, or its refreshed copy after the full record loads.
   */
  rowSelected(e: AbsiResource) {
    setTimeout(() => {
      if (this.absi?.id != e.id) {
        this.setHeights();
        this.scrollToTop('sidenav-content');
        // Bug 6961: the expanded list leaves too little room for the checklist on tablets and phones
        if (window.innerWidth < 992) this.isExpanded = false;
      }
      this.absi = e;
    }, 100);
  }


  create() {
    this.absi = new AbsiResource();
    this.absi.createdOn = new Date();
    this.isCreating = true;
    this.disableSchedules();
  }

  createNew() {
    if (this.absi) {
      this.absi.scheduleId = this.schedule?.id;
      this.absi.type = this.absiTemplateType?.id;
      this.absi.typeName = this.absiTemplateType?.name;
      const template = this.absiTemplateType?.absiTemplates?.find(x => x.status == 1);
      this.absi.versionName = template?.name;
      this.absi.wfTableID = template?.wfTableID;
      this.isCreating = false;
      this.service.createNew(this.absi).toPromise().then(data => {
        const absiId = data ?? 0;
        this.setOpenDocument(this.formTypeEnum.ABSI, absiId);
        this.side!.selectedRowIndex = absiId;
        this.service.getById(absiId).subscribe(createdAbsi => {
          this.store.dispatch(new AbsiUpdate(absiId, createdAbsi));
          this.absi = createdAbsi;
          this.side?.getValues(createdAbsi);
        });
      }).catch(error => {
        this.alert.defaultError();
        console.error(error);
      }).finally(() => {
      });
    }
  }

  cancelNew() {
    this.absi = undefined;
    this.isCreating = false;
  }

  buttonsVisible: boolean | null = false;

  catlReport() {
    const report = this.dialog.open(CatlReportComponent, {
      width: '80vw',
      data: this.absi
    });
    report.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  cancel() {
    const cancelDialog = this.dialog.open(RejectDialogComponent, {
      width: '600px',
      data: {
        warning: this.getMessage('RejectDialogWarning').description,
        title: this.getMessage("GenericActionConfirmation").description?.replace('{action}', '<b class="red">Cancel</b>').replace('{item}', `this <b class="blue">ABSI Checklist (${this.absi?.serialNo})</b>`),
        placeholder: 'Please provide a reason for canceling this ABSI Checklist',
        icon: true,
      },
    });

    cancelDialog.afterClosed().subscribe((data) => {
      if (data.accept) {
        const absi = { ...this.absi } as SaveAbsiStatusResource;
        absi.status = FormStatusEnum.Canceled;
        absi.cancelReason = data.text;
        this.service.setStatus(absi).subscribe(() => {
          this.alert.message("ABSI_CancelNotification", [new MessagePlaceholder("{serialNo}", this.absi?.serialNo), new MessagePlaceholder("{reason}", '<b>' + data.text + '</b>')], MessageTypeEnum.Error, 'ABSI Canceled!');
        });
      }
    });
  }

  filterSchedules(e?: any) {
    const filterValue = e?.target.value?.toLowerCase();
    this.schedulesFiltered = this.schedules?.filter(
      (o) => o.name?.toLowerCase().includes(filterValue)
    );
  }

  onScheduleSelected(e: MatAutocompleteSelectedEvent) {
    this.schedule = e.option?.value as Schedule;
    this.absi!.scheduleId = this.schedule.id;
  }

  commentsSummary() {
    const report = this.dialog.open(CommentsSummaryComponent, {
      height: '85vh',
      width: '80vw',
      minHeight: '680px',
      data: this.absi
    });
    report.afterClosed().subscribe((data) => {
    });
  }

}
